/**
 * Tiny UI helpers used to replace common nested-ternary patterns.
 *
 * Why: chained `cond1 ? a : cond2 ? b : c` is readable but trips
 * `no-nested-ternary`. These helpers solve the rule and produce more
 * grep-friendly code without sacrificing clarity.
 */

/**
 * Return the first map value whose key matches the input.
 *
 *   pick('saved', { saving: 'A', saved: 'B' }, 'C')  // 'B'
 *   pick('foo',   { saving: 'A', saved: 'B' }, 'C')  // 'C'
 */
export function pick(key, map, fallback = null) {
  return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : fallback;
}

/**
 * Pick the first matching tier in a descending threshold list.
 *
 *   tier(rating, [[3, 'green'], [2, 'blue'], [1, 'amber']], 'red')
 *   // rating=5 -> 'green', rating=2.5 -> 'blue', rating=0 -> 'red'
 */
export function tier(value, thresholds, fallback) {
  for (const t of thresholds) {
    if (value >= t[0]) return t[1];
  }
  return fallback;
}
